import { render, staticRenderFns } from "./WalterIASidePanel.vue?vue&type=template&id=049e4de3&scoped=true"
import script from "./WalterIASidePanel.vue?vue&type=script&lang=js"
export * from "./WalterIASidePanel.vue?vue&type=script&lang=js"
import style0 from "./WalterIASidePanel.vue?vue&type=style&index=0&id=049e4de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e4de3",
  null
  
)

export default component.exports